import React, {useState, useEffect} from 'react';
import '../../App.css';
import TypicalSearchBar from '../../components/TypicalSearchBar';
import WebInfoCard from '../../components/WebInfoCard';
import WebSummaryCard from '../../components/WebSummaryCard';
import ViewMoreButton from '../../components/ViewMoreButton';
import {FetchSearch} from "./FetchSearch";
import { useLocation } from 'react-router-dom';

const SearchPage = (url) => {
  const fetchSearch = new FetchSearch("blah");

  const [similarPages, setSimilarPages] = useState(fetchSearch.getSimilarDocs());
  const [contradictingPages, setContradictingPages] = useState(fetchSearch.getDiffDocs());
  const location = useLocation(); 
  const queryParams = new URLSearchParams(location.search); 
  const searchTerm = queryParams.get('query');

  const [loading, setLoading] = useState(true); 
  const [loadingSimilar, setLoadingSimilar] = useState(true); 
  const [loadingContradicting, setLoadingContradicting] = useState(true); 

  useEffect(() => {
    // Simulate a delay of 20 seconds before displaying content
    const timer = setTimeout(() => {
      setLoading(false); // Stop loading after 20 seconds
    }, 2000);

    return () => clearTimeout(timer); // Clean up the timer on component unmount
  }, []);

  useEffect(() => {
    // Simulate a delay of 20 seconds before displaying similar pages
    const timerSimilar = setTimeout(() => {
      setSimilarPages(fetchSearch.getSimilarDocs());
      setLoadingSimilar(false); // Stop loading similar pages after 20 seconds
    }, 2000);

    return () => clearTimeout(timerSimilar); // Clean up the timer on component unmount
  }, []);

  useEffect(() => {
    // Simulate a delay of 20 seconds before displaying contradicting pages
    const timerContradicting = setTimeout(() => {
      setContradictingPages(fetchSearch.getDiffDocs());
      setLoadingContradicting(false); // Stop loading contradicting pages after 20 seconds
    }, 2000);

    return () => clearTimeout(timerContradicting); // Clean up the timer on component unmount
  }, []);


  const handleViewMoreSimilar = () => {
    const newItems = [
      <WebSummaryCard websiteIcon={"blah"}
                      websiteName={"website name"}
                      pageName={"page name"}
                      pageSummary={"this is a summary"}
                      key={similarPages.length} />,
      <WebSummaryCard websiteIcon={"blah 2"}
                      websiteName={"website name 2"}
                      pageName={"page name 2"}
                      pageSummary={"this is a summary 2"}
                      key={similarPages.length + 1} />,
      <WebSummaryCard websiteIcon={"blah 3"}
                      websiteName={"website name 3"}
                      pageName={"page name 3"}
                      pageSummary={"this is a summary 3"}
                      key={similarPages.length + 2} />
    ];
    setSimilarPages([...similarPages, ...newItems]);
  };

  const handleViewMoreContradicting = () => {
    const newItems = [
      <WebSummaryCard websiteIcon={"blah"}
                      websiteName={"website name"}
                      pageName={"page name"}
                      pageSummary={"this is a summary"}
                      key={similarPages.length} />,
      <WebSummaryCard websiteIcon={"blah 2"}
                      websiteName={"website name 2"}
                      pageName={"page name 2"}
                      pageSummary={"this is a summary 2"}
                      key={similarPages.length + 1} />,
      <WebSummaryCard websiteIcon={"blah 3"}
                      websiteName={"website name 3"}
                      pageName={"page name 3"}
                      pageSummary={"this is a summary 3"}
                      key={similarPages.length + 2} />
    ];
    setContradictingPages([...contradictingPages, ...newItems]);
  };

  return (
    <div className='SearchPage'>
      <TypicalSearchBar searchTerm={searchTerm}/>
      <div className='RecordsContainer my-4'>
      {loading ? (
          <div className="loading-icon"> 
            <img src="https://upload.wikimedia.org/wikipedia/commons/3/3a/Gray_circles_rotate.gif" alt="Loading" />
          </div>
        ) : (
          fetchSearch.getCurrentDoc()
        )}
      </div>
      <hr />
      <div className='RecordsContainer my-4'>
        <h3>Similar Pages</h3>
        <div className='SimilarItems'>
        {loadingSimilar ? (
            <div className="loading-icon">
              <img src="https://upload.wikimedia.org/wikipedia/commons/3/3a/Gray_circles_rotate.gif" alt="Loading" />
            </div>
          ) : (
            <ul>
              {similarPages.map((page, index) => (
                <li key={index}>{page}</li>
              ))}
            </ul>
          )}
          {!loadingSimilar && <ViewMoreButton onClick={handleViewMoreSimilar} />}
        </div>
        <h3>Contradicting Pages</h3>
        <div className='SimilarItems'>
        {loadingContradicting ? (
            <div className="loading-icon">
              <img src="https://upload.wikimedia.org/wikipedia/commons/3/3a/Gray_circles_rotate.gif" alt="Loading" />
            </div>
          ) : (
            <ul>
              {contradictingPages.map((page, index) => (
                <li key={index}>{page}</li>
              ))}
            </ul>
          )}
          {!loadingContradicting && <ViewMoreButton onClick={handleViewMoreContradicting} />}
        
        </div>
      </div>
      
    </div>
  );
};

export default SearchPage;
